import { fromPromise } from 'rxjs/internal-compatibility';
import App from '../../../app';

const dataLayer = window.dataLayer || [];
const AMPLITUDE_EVENT_NAME = "Pageview: Devices";

const gtmEvents = {
  devicesListSearching: 'devicesListSearching',
  devicesListRefreshDevice: 'devicesListRefreshDevice',
};

const DevicesListController = (
  $scope,
  $timeout,
  installationsService,
  devicesService,
  gettextCatalog,
) => {
  'ngInject';

  $scope.pageSize = 14;

  $scope.query = '';

  // Local Variables
  const pageLimit = 30;

  $scope.showSingleInstallPanel = false;
  $scope.showBulkInstallPanel = false;
  $scope.pagedInstallations = [];
  // represent currentPage index in pagedInstallations
  $scope.currentPage = 0;
  $scope.xMoreDataAvailable = false;
  $scope.canDelete = false;
  $scope.nextPageOffset = [];
  $scope.currentSearchTerm = '';
  $scope.transferKeys = [];
  $scope.unavailable = 'Unavailable';

  // to highlight rows when refreshing
  $scope.selectedRow = null;

  let nextPageSubscription = null;

  $scope.previousPage = () => {
    $scope.currentPage -= 1;
    $scope.pagedInstallations.pop();
    $scope.nextPageOffset.pop();

    // If next page is loading, cancel it
    if (nextPageSubscription !== null) {
      $scope.showInstallationsSpinner = false;
      nextPageSubscription.unsubscribe();
      nextPageSubscription = null;
    }
  };

  const onInit = () => {
    App.amplitude.track(AMPLITUDE_EVENT_NAME);
  }

  $scope.sortString = 'created:desc';

  const updateResults = (data, _status, headers) => {
    $scope.showInstallationsSpinner = false;
    $scope.pagedInstallations.push(data);
    $scope.currentPage = $scope.pagedInstallations.length - 1;

    $scope.xMoreDataAvailable = headers('x-more-data-available') === 'true';
    $scope.nextPageOffset.push(
      $scope.xMoreDataAvailable ? headers('link').match(/.*since\=(\d+).*/)[1] : '',
    );
  };

  const notRefreshingData = (data) =>
    [...data].map((d) => ({
      ...d,
      isRefreshing: false,
      selectedRow: -1,
    }));

  const errorOccured = gettextCatalog.getString(
    'An error occurred while retrieving device information',
  );

  const formatErrorMessage = (error) =>
    error.data.message
      ? `${error.data.message} ${error.status} - ${error.statusText}`
      : `${errorOccured}: ${error.status} - ${error.statusText}`;

  const getErrorMessage = (error) =>
    error.data || error.status
      ? formatErrorMessage(error)
      : `${errorOccured}. ${gettextCatalog.getString('Please try again later')}.`;

  $scope.search = (query) => {
    $scope.errorFlag = false;
    $scope.nextPageOffset = [''];
    $scope.pagedInstallations = [];
    $scope.currentPage = 0;
    $scope.loading = true;

    // push the search event to the data layer.
    dataLayer.push({
      event: gtmEvents.devicesListSearching,
      data: {
        query,
      },
    });

    installationsService
      .getInstallations(
        pageLimit,
        $scope.sortString,
        $scope.nextPageOffset[$scope.nextPageOffset.length - 1],
        query,
        null,
      )
      .then(
        (response) => {
          $scope.loading = false;
          if (response.data) {
            updateResults(notRefreshingData(response.data), response.status, response.headers);
          }
        },
        (error) => {
          $scope.loading = false;
          $scope.errorFlag = true;
          $scope.errorText = getErrorMessage(error);
        },
      );
  };

  $scope.nextPage = () => {
    if (!$scope.xMoreDataAvailable) return;
    $scope.showInstallationsSpinner = true;
    $scope.errorFlag = false;
    nextPageSubscription = fromPromise(
      installationsService.getInstallations(
        pageLimit,
        $scope.sortString,
        $scope.nextPageOffset[$scope.nextPageOffset.length - 1],
      ),
    ).subscribe(
      (response) => updateResults(response.data, response.status, response.headers),
      (error) => {
        $scope.showInstallationsSpinner = false;
        $scope.errorFlag = true;
        $scope.errorText = getErrorMessage(error);
      },
    );
  };

  // function that sets the value of selectedRow to current index
  const setClickedRow = (installation) => {
    installation.selectedRow = installation.id;
  };

  $scope.refreshDevice = (serialNumber, installation) => {
    installation.isRefreshing = true;
    $scope.refreshErrorFlag = false;

    // push the refresh event to the data layer.
    dataLayer.push({
      event: gtmEvents.devicesListRefreshDevice,
      data: {
        serialNumber,
        installation,
      },
    });

    devicesService.getDevice(serialNumber).then(
      (response) => {
        const { data: device } = response;

        installation.isRefreshing = false;

        const { communicatedAt } = device;
        if (communicatedAt) {
          // highlight table row green
          // set install.device.communicatedAt to device.communicatedAt
          // should automagically changed button and status icon to green
          installation.device.communicatedAt = communicatedAt;
        }
        setClickedRow(installation);

        $timeout(() => {
          installation.selectedRow = -1;
        }, 3000);
      },
      (error) => {
        installation.isRefreshing = false;
        $scope.refreshErrorFlag = true;
        $scope.refreshErrorText = getErrorMessage(error);
      },
    );
  };

  // ON INIT
  $scope.search();

  onInit();
};

export default DevicesListController;
